import React, { Fragment, useEffect } from 'react';

const Redirection = () => {
  useEffect(() => {
    // eslint-disable-next-line no-undef
    const iosStoreLink = import.meta.env.VITE_IOS_APP_STORE_LINK ?? '/';
    // eslint-disable-next-line no-undef
    const androidStoreLink = import.meta.env.VITE_ANDROID_APP_STORE_LINK ?? '/';

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // iOS detection
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) window.location.href = iosStoreLink;
    // Android detection
    else if (/android/i.test(userAgent)) window.location.href = androidStoreLink;
    // Fallback or desktop
    else window.location.href = '/';
  }, []);

  return <Fragment></Fragment>;
};

export default Redirection;
